import {Space, Tooltip, Typography} from 'antd';
import React from 'react';

import {DynamicIcon} from 'components/dynamic-icon';
import {IFieldMeta} from 'entities/metadata';

export interface IFieldLabelProps {
    fieldMeta: IFieldMeta;
    label: string;
}

export const FieldLabel = ({fieldMeta, label}: IFieldLabelProps) => (
    <Space>
        <Typography.Text>{label}</Typography.Text>
        {fieldMeta?.hint && (
            <Tooltip title={fieldMeta.hint}>
                <DynamicIcon type="QuestionCircleOutlined" />
            </Tooltip>
        )}
    </Space>
);
